import { FormattedMessage } from 'react-intl';
import BulkBookingInputs from 'Modules/BulkBooking/Components/BulkBookingInputs';
import { BookingWizardData } from '../../BookingWizardData/BaseBookingWizardData';
import { useBookingWizardDataStore } from '../../BookingWizardDataStore';
import { MessageBox } from 'Views/Components/_HumanWritten/MessageBox/MessageBox';
import { WizardStepHeader } from '../Shared/WizardStepHeader';
import { appConfigStore } from 'Models/AppConfigStore';

export default function BulkTicketsCriteriaTab() {
	const { wizardData, setWizardData } = useBookingWizardDataStore();

	const filters = wizardData.bulkBookingFilters!; // this Component should only be used when bulkBookingFilters is defined

	return (
		<div className="p-4 mb-16">
			<WizardStepHeader
				iconName="search"
				title={<FormattedMessage id="booking-wizard__bulk-tickets__find__header" defaultMessage="Find trips" />}
				subtitle={
					<FormattedMessage
						id="booking-wizard__bulk-tickets__find__subtitle"
						defaultMessage="Search for ferry trips to include in your bulk booking."
					/>
				}
			/>
			<MessageBox status="info" noBottomMargin className="mb-4">
				<FormattedMessage
					id="booking-wizard__bulk-tickets__find__max-info"
					defaultMessage="A maximum of {max} bulk bookings can be made."
					values={{ max: appConfigStore.bulkBookingsMaxTrips }}
				/>
			</MessageBox>
			<section className="booking-section-card">
				<BulkBookingInputs
					value={filters}
					errors={filters.errors}
					onChange={updates => {
						const newErrors = { ...filters.errors };
						Object.keys(updates).forEach(key => {
							delete newErrors[key];
						});

						setWizardData(
							new BookingWizardData({
								...wizardData,
								bulkBookingFilters: {
									...filters,
									...updates,
									errors: newErrors,
								},
							}),
						);
					}}
				/>
			</section>
		</div>
	);
}
